import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as reducks from '../../../reducks'
import routes from '../../../config/routes'
import Flex from '../../commons/Flex/Flex'
import Text from '../../commons/Text/Text'
import Breadcrumb from '../../commons/Breadcrumb/Breadcrumb'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import Card from '../../commons/Card/Card'
import ProfileForm from './ProfileForm'
import LoadingBounce from '../../commons/LoadingBounce/LoadingBounce'
import Avatar from '../../commons/Avatar/Avatar'
import styles from './profileDetail.module.scss'

const breadcrumbs = [
  {
    id: 1,
    title: 'Meu perfil',
    path: routes.profile.path
  },
  {
    id: 2,
    title: 'Contato'
  }
]

const ProfileDetailContainer = () => {
  const dispatch = useDispatch()
  const profile = useSelector((state) => state.profileReducer)

  const handleSubmit = (values) => {
    dispatch(
      reducks.resources.profile.actions.updateProfile({
        phone_number_cell: values.phone
      })
    )
  }

  return (
    <DefaultLayout>
      <Flex column justifyContent="flex-start">
        <Text
          size="lg"
          color="gray"
          variation="dark"
          extraBold
          lineHeight="30px"
        >
          Editar dados de contato
        </Text>
        <Breadcrumb items={breadcrumbs} />

        {!profile.fetching && (
          <div className={styles.row}>
            <Flex
              alignItems="flex-start"
              style={{ width: '100%', maxWidth: '546px' }}
            >
              <Card className={styles.cardMargin}>
                <Flex
                  column
                  alignItems="flex-start"
                  justifyContent="space-evenly"
                >
                  <div className={styles.mb20}>
                    <Avatar
                      title={profile.profile.name}
                      image={profile.profile.profileImageUrl}
                      size="small"
                    />
                  </div>
                  <Text
                    size="md"
                    color="gray"
                    variation="dark"
                    bold
                    lineHeight="24px"
                  >
                    {profile.profile.name}
                  </Text>
                  <Text
                    size="xs"
                    color="gray"
                    lineHeight="24px"
                    margin="11px 0px 0px 0px"
                  >
                    Edite suas informações pessoais e seus dados de contato
                  </Text>
                </Flex>
              </Card>
            </Flex>

            <Flex column style={{ gap: 30, width: '100%', maxWidth: '546px' }}>
              <Card className={styles.cardMargin}>
                <Flex
                  column
                  alignItems="flex-start"
                  justifyContent="space-between"
                >
                  <Text
                    size="md"
                    color="gray"
                    variation="dark"
                    bold
                    lineHeight="24px"
                    margin="30px 0px 40px 0px"
                  >
                    E-mail
                  </Text>

                  <Flex
                    flex="1"
                    alignItems="center"
                    justifyContent="space-between"
                    style={{ width: '100%' }}
                  >
                    <Text font="custom" size="xs" color="gray" variation="dark">
                      {profile.profile.email}
                    </Text>
                    <Text
                      font="custom"
                      size="xxs"
                      color="quaternary"
                      variation="dark"
                    >
                      Confirmado
                    </Text>
                  </Flex>
                </Flex>
              </Card>

              <ProfileForm
                handleSubmit={handleSubmit}
                fetching={profile.fetching}
                initialValues={{
                  phone: profile.profile.phoneNumberCell
                }}
              />
            </Flex>
          </div>
        )}

        {profile.fetching && <LoadingBounce />}
      </Flex>
    </DefaultLayout>
  )
}

export default ProfileDetailContainer
